<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("appraisal module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("map configuration") }}</h1>

        <div class="field">
          <label class="label">{{ $t("default map zoom") }}</label>
          <div class="control">
            <input
              type="number"
              class="input"
              v-model="meta.default_map_zoom"
              min="1"
              max="20"
              :placeholder="$t('default map zoom')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label"
            >{{ $t("default map center") }} ({{ $t("latitude") }})</label
          >
          <div class="control">
            <input
              type="number"
              class="input"
              v-model="meta.default_map_center_lat"
              step="0.000001"
              :placeholder="$t('latitude')"
            />
          </div>
        </div>

        <div class="field">
          <label class="label"
            >{{ $t("default map center") }} ({{ $t("longitude") }})</label
          >
          <div class="control">
            <input
              type="number"
              class="input"
              v-model="meta.default_map_center_lng"
              step="0.000001"
              :placeholder="$t('longitude')"
            />
          </div>
        </div>

        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_enable_clustering"
            v-model="meta.enable_map_clustering"
          />
          <label for="chk_enable_clustering">{{
            $t("enable map clustering")
          }}</label>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button
            class="button is-rounded is-primary"
            @click="save"
            :class="{ 'is-loading': saving }"
            :disabled="saving"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
} from "@/utils";

export default {
  name: "AppraisalSettings",
  data() {
    return {
      saving: false,
      meta: {
        default_map_zoom: 10,
        default_map_center_lat: 14.6349, // Guatemala City
        default_map_center_lng: -90.5069,
        enable_map_clustering: false,
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.saving = true;

      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.saving = false;
        });
    },
  },
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = { ...v.meta, ...conf };
        }
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>
